import { IForm } from '@/components/types'
import { useSearchVideoTitle } from '@/hooks/useSearch'

const [fetchSuggestions] = useSearchVideoTitle()

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'title',
      type: 'autocomplete',
      label: '视频标题',
      placeholder: '请输入视频标题',
      otherOptions: {
        clearable: true,
        'fetch-suggestions': fetchSuggestions
      }
    },
    {
      field: 'consumerNickName',
      type: 'input',
      label: '客户昵称',
      placeholder: '请输入昵称全名'
    },
    {
      field: 'accessTime',
      type: 'datepicker',
      label: '访问时间',
      otherOptions: {
        startPlaceholder: '开始时间',
        endPlaceholder: '结束时间',
        type: 'daterange',
        'value-format': 'YYYY-MM-DD',
        disabledDate: (date: Date) => {
          return new Date() < date
        }
      }
    },
    {
      field: 'empIds',
      type: 'select',
      label: '员工',
      clearable: true,
      filterable: true,
      placeholder: '请选择员工'
    }
  ]
}
